import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element }) => {
  const token = sessionStorage.getItem('authToken'); 

 
  
  return token ? element : <Navigate to="/" replace />; 
};

export default ProtectedRoute;
